import { useEffect, useState } from 'react';
import { callFn } from '../lib/api';
import type { Media } from '../lib/types';

export function MediaPicker({ onClose, onSelect }: { onClose: () => void; onSelect: (media: Media) => void }) {
  const [media, setMedia] = useState<Media[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    callFn<Media[]>('list_media').then(setMedia).catch(() => {}).finally(() => setLoading(false));
  }, []);
  return (
    <div className="modal-bg" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 640 }} onClick={(e) => e.stopPropagation()}>
        <h3>Choose from media library</h3>
        <p className="page-sub" style={{ marginTop: 0 }}>Newest uploads first.</p>
        {loading ? <div className="loading">Loading…</div>
          : media.length === 0 ? <div className="empty">No images yet — upload one and it&rsquo;ll appear here.</div>
          : (
            <div className="media-grid">
              {media.map((m) => (
                <button key={m.id} type="button" className="media-tile" title={m.filename || ''} onClick={() => onSelect(m)}>
                  <img src={m.url} alt={m.filename || ''} loading="lazy" />
                  <span className="media-tile-cap">
                    <span className="media-tile-name">{m.filename || 'image'}</span>
                    <span className="media-tile-date">{new Date(m.created_at).toLocaleDateString()}</span>
                  </span>
                </button>
              ))}
            </div>
          )}
        <div className="row" style={{ marginTop: 14 }}>
          <button className="btn secondary" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
